import React, { useRef, useEffect } from 'react';
import { FocusScope } from '@react-aria/focus';
import PropTypes from 'prop-types';
import { Wrapper, StyledSlidingContainer, Overlay } from './styles.js';

export const SlidingContainer = ({
  children,
  onExit,
  active,
  bgColor = 'background.base',
  alignment = 'right',
  offsetTop,
  maxWidth = 480,
}) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (active) {
      const offsetY = window.pageYOffset;
      document.body.style.top = `${-offsetY}px`;
      document.body.style.position = 'fixed';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('width');
      document.body.style.overflow = 'visible';
    }
  }, [active]);

  return (
    <Wrapper forward={active}>
      <Overlay active={active} ref={overlayRef} onClick={() => onExit()} />
      <StyledSlidingContainer
        active={active}
        bgColor={bgColor}
        alignment={alignment}
        top={offsetTop}
        maxWidth={maxWidth}
      >
        {active && (
          <FocusScope contain restoreFocus autoFocus>
            {children}
          </FocusScope>
        )}
      </StyledSlidingContainer>
    </Wrapper>
  );
};

SlidingContainer.displayName = 'SlidingContainer';

SlidingContainer.propTypes = {
  children: PropTypes.node,
  onExit: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  bgColor: PropTypes.oneOf(['background.lightest', 'background.base']),
  alignment: PropTypes.oneOf(['left', 'right']),
  offsetTop: PropTypes.number,
  maxWidth: PropTypes.number,
};
